import ResourceTyped, { Metadata } from './ResourceTyped';

export type EventNews = {
	id: number;
	medium: number;
	name: string;
	content: string;
	prospecingId: string;
	title: string;
	date: string;
	url: string;
	pinned: boolean;
	img: null | string;
	latestPubDate: string;
	link: string;
};

class News extends ResourceTyped<EventNews> {
	constructor() {
		super('news');
	}

	getClientNews(
		clientId: number,
		params: { subAccountIds?: number[]; limit?: number; offset?: number } = {}
	): Promise<{ data: EventNews[]; metadata: Metadata }> {
		return this._getRequest(`${clientId}`, {
			methodName: 'getClientNews',
			params
		}).then(response => response.data);
	}
}

const newsResource = new News();

export default newsResource;
